export default __webpack_public_path__ + "../staticImages/lagerverkauf-260.png";